import { Box, HStack, Link, Image, IconButton, useDisclosure, VStack, Collapse } from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { motion } from "framer-motion";
import logo from "../assets/Logo-Sedapé-fundo-branco.webp";

const MotionBox = motion(Box);

export default function Navbar() {
  const { isOpen, onToggle } = useDisclosure();

  const navLinks = [
    { label: "Nossa História", href: "#story" },
    { label: "Benefícios", href: "#features" },
    { label: "Depoimentos", href: "#testimonials" },
    { label: "Passos", href: "#steps" },
    { label: "Contato", href: "#footer" },
  ];

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      // fecha o menu primeiro
      onToggle();
      // espera 300ms (tempo da animação do Collapse)
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 300);
    }
  };

  return (
    <MotionBox
      as="nav"
      top={0}
      zIndex={1000}
      bg="white"
      py={2}
      px={{ base: 6, md: 24 }}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <HStack justifyContent="space-between">
        {/* Logo */}
        <Link href="#hero">
          <Image
            src={logo}
            alt="Sedapé Logo"
            objectFit="cover"
            maxW="300px"
            maxH="100px"
            transform={"scale(1.6)"}
          />
        </Link>

        {/* Menu Desktop */}
        <HStack spacing={8} display={{ base: "none", md: "flex" }}>
          {navLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              _hover={{ textDecoration: "none", color: "sedapePinkDark" }}
            >
              {link.label}
            </Link>
          ))}
        </HStack>

        {/* Menu Mobile */}
        <IconButton
          display={{ base: "flex", md: "none" }}
          aria-label="Toggle Menu"
          icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
          onClick={onToggle}
          variant="ghost"
        />
      </HStack>

      {/* Links Mobile */}
      <Collapse in={isOpen} animateOpacity>
        <VStack
          bg="white"
          p={4}
          display="flex"
          spacing={4}
          shadow="md"
          borderRadius="md"
          mt={2}
        >
          {navLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              w="100%"
              textAlign="center"
              _hover={{ textDecoration: "none", color: "sedapePinkDark" }}
              onClick={() => scrollToSection(link.href.replace("#", ""))}
            >
              {link.label}
            </Link>
          ))}
        </VStack>
      </Collapse>
    </MotionBox>
  );
}
